<template>
  <div class="notification-container" v-if="notifications.length">
    <transition-group name="list" tag="div">
      <div v-for="(notification, index) in notifications" :key="notification.id" :class="`notification ${notification.type}`">
        {{ notification.message }}
        <v-btn icon @click="removeNotification(index)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'Notifications',
  data() {
    return {
      notifications: []
    };
  },
  methods: {
    addNotification(message, type) {
      const id = Date.now();
      this.notifications.push({ id, message, type });
      setTimeout(() => {
        this.removeNotificationById(id);
      }, 25000); // auto-remove after 5 seconds
    },
    removeNotification(index) {
      this.notifications.splice(index, 1);
    },
    removeNotificationById(id) {
      const index = this.notifications.findIndex(notification => notification.id === id);
      if (index !== -1) {
        this.removeNotification(index);
      }
    },
    listenToParentEvents() {
      this.$parent.$on('readOutLoud', message => {
        this.addNotification(message, 'blue');
      });
      this.$parent.$on('alert', message => {
        this.addNotification(message, 'green');
      });
      this.$parent.$on('error', message => {
        this.addNotification(message, 'red');
      });
      this.$parent.$on('loadingText', message => {
        this.addNotification(message, 'orange');
      });
    }
  },
  created() {
    this.listenToParentEvents();
  }
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  bottom: 90px;
  right: 10px;
  z-index: 1000;
}
.notification {
  margin-bottom: 10px;
  padding: 20px;
  border-radius: 8px;
  color: rgb(255, 255, 255);
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  background: linear-gradient(145deg, rgba(12, 22, 27, 0.6), rgba(12, 22, 27, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.18); /* Adding a border for a more defined edge */
}
.blue {
  background-color: rgba(103, 103, 244, 0.537);
  box-shadow: 0 0 15px rgba(103, 103, 244, 0.537);
}
.green {
  background-color: rgba(51, 148, 51, 0.555);
  box-shadow: 0 0 15px rgba(51, 148, 51, 0.555);
}
.red {
  background-color: rgba(161, 17, 17, 0.593);
  box-shadow: 0 0 15px rgba(161, 17, 17, 0.593);
}
.orange {
  background-color: rgba(255, 165, 0, 0.579); /* Adjusted for a brighter orange */
  box-shadow: 0 0 15px rgba(255, 165, 0, 0.579);
}
.list-enter-active, .list-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
